export class AlertChannel {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "kind",
            "baseName": "kind",
            "type": "AlertChannelKind",
            "format": ""
        },
        {
            "name": "target",
            "baseName": "target",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AlertChannel.attributeTypeMap;
    }
    constructor() {
    }
}
